import styled from 'styled-components';
import { FilterAlt } from '@styled-icons/material/FilterAlt';

export const Container = styled.div`
  width: 97%;
  display: flex;
  margin: 2rem auto 1rem auto;
  align-items: flex-start;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.breakpoints.laptopL};
    flex-direction: row;
  }

  & > .title-container {
    display: flex;
    align-items: center;
    font-size: 0.75rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.blue4};
    margin-right: 1rem;
  }

  & > .tags-container {
    flex-grow: 1;
    display: flex;
    flex-wrap: wrap;
    margin-top: 1rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin-top: unset;
    }
  }
`;

export const FilterIcon = styled(FilterAlt)`
  width: 1.5rem;
  margin-right: 0.875rem;
`;

export const FilterTag = styled.div`
  background-color: ${({ theme }) => theme.colors.blue4};
  color: ${({ theme }) => theme.colors.white};
  font-size: 0.75rem;
  padding: 0.125rem 0.5rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
  min-width: 3rem;
  min-height: 1.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayAntdBorder};

  animation: opacity 0.25s ease-in;
  @keyframes opacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  &.remove-tag {
    animation: removeOpacity 0.5s ease-out;
    @keyframes removeOpacity {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }

  &:hover {
    opacity: 0.9;
  }

  & > span {
    font-weight: 400;

    & > span.filter-type {
      font-weight: 600;
    }
  }

  & > button {
    font-size: 0.875rem;
    margin-left: 0.5rem;
    cursor: pointer;
    width: 1rem;
    background: none;
    border: none;

    &:hover {
      font-weight: 700;
    }
  }
`;
